import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer'; // Footer general

import Navbar2 from './components/Navbar2'; // Navbar para español
import Footer2 from './components/Footer2'; // Footer para español

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/pages/Home';
import About from './components/pages/About';
import Products from './components/pages/Products';
import Contact from './components/pages/Contact';
import Login from './components/pages/Login';
import Home2 from './components/pages/Esp/Home2';
import About2 from './components/pages/Esp/About2';
import Contact2 from './components/pages/Esp/Contact2';
import AdminUsersPanel from './components/pages/AdminUserPanel';
import UserTable from './components/pages/UserTable';
import UserRegistration from './components/pages/UserRegistration';
import UserManagementTable from './components/pages/UserManagementTable';
import ProductRegistration from './components/pages/ProductRegistration';
import PDFOpenerCard from './components/pdfver';
import ProductosBeds from './components/pages/categoriasProductos/ProductosBeds';
import ProductosCasung from './components/pages/categoriasProductos/ProductosCasung';
import ProductosCoves from './components/pages/categoriasProductos/ProductosCoves';
import AllProducs from './components/pages/UserVerificados/AllProducs';
import Products2 from './components/pages/Esp/Products2';
import ProductosCoves2 from './components/pages/Esp/ProductosCoves2';
import ProductosCasung2 from './components/pages/Esp/ProductosCasung2';
import ProductosBeds2 from './components/pages/Esp/ProductosBeds2';
import ProductosStop from './components/pages/categoriasProductos/ProductosStop';
import ProductosStop2 from './components/pages/Esp/ProductosStops2';
import LoginAdmin from './components/pages/LoginAdmin';



import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <BrowserRouter>
      {/* Rutas generales */}
      <Routes>
        {/* Rutas en inglés con el Navbar general */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route index element={<Home />} /> {/* Ruta por defecto a /home */}
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path='/AdminUsersPanel' element={<AdminUsersPanel/>}/>
                <Route path='/UserTable' element={<UserTable/>}/>
                <Route path='/UserRegistration' element={<UserRegistration/>}/>
                <Route path='/UserManagementTable' element={<UserManagementTable/>}/>
                <Route path='/ProductRegistration' element={<ProductRegistration/>}/>
                <Route path='/pdfver' element={<PDFOpenerCard/>}/>
                <Route path="/products/beds" element={<ProductosBeds />} />
                <Route path="/products/casung" element={<ProductosCasung />} />
                <Route path="/products/coves" element={<ProductosCoves />} />
                <Route path="/products/stops" element={<ProductosStop />} />
                <Route path="/products/all" element={<AllProducs />} />
                <Route path="/LoginAdmin" element={<LoginAdmin />} />
                


                
              </Routes>
              <Footer /> {/* Footer general */}
            </>
          }
        />

        {/* Rutas en español con el Navbar específico */}
        <Route
          path="/es/*"
          element={
            <>
              <Navbar2 />
              <Routes>
                <Route index element={<Home2 />} /> {/* Ruta por defecto a /es/home */}
                <Route path="home" element={<Home2 />} />
                <Route path="/about" element={<About2 />} />
                <Route path="/products" element={<Products2 />} />
                <Route path="/contact" element={<Contact2 />} />
                <Route path="/login" element={<Login />} />
                <Route path='/AdminUsersPanel' element={<AdminUsersPanel/>}/>
                <Route path='/UserTable' element={<UserTable/>}/>
                <Route path='/UserRegistration' element={<UserRegistration/>}/>
                <Route path='/UserManagementTable' element={<UserManagementTable/>}/>
                <Route path='/ProductRegistration' element={<ProductRegistration/>}/>
                <Route path='/pdfver' element={<pdfver/>}/>
                <Route path="/products/beds" element={<ProductosBeds2 />} />
                <Route path="/products/casung" element={<ProductosCasung2 />} />
                <Route path="/products/coves" element={<ProductosCoves2 />} />
                <Route path="/products/stops" element={<ProductosStop2 />} />



              </Routes>
              <Footer2 /> {/* Footer en español */}
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
